import { Component, OnInit, inject } from '@angular/core';
import { AdminAccountUMClient, SimpleProfileQueryFilter, IProfileResponse } from 'src/app/api/api-user-management.service.generated';
import { Observable, BehaviorSubject, lastValueFrom } from 'rxjs';
import { map, switchMap, debounceTime } from 'rxjs/operators';
import { LoadingAwareComponent } from 'src/app/common/utils/loading-aware.component';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatCardModule } from '@angular/material/card';
import { AsyncPipe } from '@angular/common';
interface AccountItemModel extends IProfileResponse {
  organizationId?: string;
}
@Component({
  selector: 'app-account-search-dialog',
  templateUrl: './account-search.dialog.html',
  styleUrls: ['./account-search.dialog.scss'],
  imports: [
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatProgressSpinnerModule,
    MatTableModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    MatCardModule,
    AsyncPipe
  ]
})
export class AccountSearchDialogComponent extends LoadingAwareComponent implements OnInit {
  dialogRef = inject<MatDialogRef<AccountSearchDialogComponent>>(MatDialogRef);
  data = inject<{
    organizationId: string;
  }>(MAT_DIALOG_DATA);


  private querySubject = new BehaviorSubject<string>('');
  users$: Observable<AccountItemModel[]>;
  readonly Roles = {
    owner: 'OrganizationOwner',
    advertiser: 'Advertiser'
  };

  constructor() {
    const accountClient = inject(AdminAccountUMClient);

    super();
    this.users$ = this.querySubject.pipe(
      debounceTime(1000),
      map(query => {
        const isDigits = /^\d*$/.test(query);
        return {
          name: !isDigits && !!query ? query : undefined,
          phone: isDigits && !!query ? query : undefined
        };
      }),
      switchMap(query =>
        this.withLoading(
          accountClient.simpleSearchAccounts(new SimpleProfileQueryFilter({
            name: query.name,
            phoneNumber: query.phone
          })))
      ),
      map(resp => resp.profiles.map(
        p => {
          const ret: AccountItemModel = { ...p };
          if (!p.tags) return ret;
          const orgTag = p.tags.find(t => t.tag === 'OrganizationId');
          if (orgTag)
            ret.organizationId = orgTag.value;
          return ret;
        })
      )
    );
  }

  static async open(dialog: MatDialog, organizationId: string): Promise<AccountItemModel | undefined> {
    const result = await lastValueFrom(dialog.open(
      AccountSearchDialogComponent,
      {
        width: '600px',
        height: '700px',
        data: { organizationId }
      }
    ).afterClosed());
    return result as (AccountItemModel | undefined);
  }
  ngOnInit() {
  }

  onChange(newValue: string) {
    this.querySubject.next(newValue);
  }

  assertType(element: AccountItemModel): AccountItemModel {
    return element;
  }

  selectAccount(account: AccountItemModel) {
    this.dialogRef.close(account);
  }
}
